import * as types from './mutation-types'
import Ls from "@/services/ls";

export default {
    [types.LOAD_TABLE] (state, data) {
        state.table = data.id
        state.info = data
    },

    [types.SAVE_TABLE_INFO] (state) {
        Ls.set('table', state.table)
        Ls.set('table.info', JSON.stringify(state.info))

    },

    [types.RESET_TABLE] (state) {
        state.table = null
        state.info = {}

    },
}

